import axios from 'axios';

import { SchedulingQueue, GetBaseQueueOptions } from 'components/types';

import { SCHEDULING_QUEUE } from '../endpoints';

export const getSchedulingQueue = ({ params, signal }: GetBaseQueueOptions) =>
  axios.get<SchedulingQueue>(SCHEDULING_QUEUE, {
    signal,
    params
  });
